function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey5 } from "@churchofjesuschrist/eden-style-constants";
const Wrapper = styled.section.withConfig({
  componentId: "sc-58af31-0"
})(["position:relative;display:block;", ";"], ({
  small
}) => `border-block-end: ${small ? "" : `1px solid ${grey5}`}`);

const Drawer = ({
  open,
  small,
  onToggle = () => {},
  children,
  ...props
}) => {
  const [internalOpen, setInternalOpen] = useState(props.open);
  useEffect(() => {
    setInternalOpen(open);
  }, [open]); // If a given `onToggle` prop returns an explicit `true` or `false`, use that value
  // as the next `open` state. Otherwise, proceed as normal.

  const internalOnToggle = () => {
    let nextOpen = !internalOpen;
    const override = onToggle(nextOpen);

    if (typeof override === "boolean") {
      nextOpen = override;
    }

    setInternalOpen(nextOpen);
  };

  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    small: small
  }, props), React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    open: internalOpen,
    onToggle: internalOnToggle,
    small
  })));
};

Drawer.propTypes = {
  /** Contents rendered inside the drawer */
  children: PropTypes.node.isRequired,

  /** Whether drawer is open */
  open: PropTypes.bool,

  /** Handler called after a toggle occurs. Receives a boolean of whether it will now be open. If the handler returns an explicit `true` or `false`, this will override whether the drawer will or will not actually open. */
  onToggle: PropTypes.func,

  /** Enable small variant */
  small: PropTypes.bool
};
export default Drawer;